<div class="serchResults">
  <div class="searchResultsPresent">
    <div>
      <a (click)="redirectToHelpCenter()" class="help-link">
        <img src="" target="_blank" class="linkText" />
        Help Center
      </a>
    </div>
    @if (searchResult && searchResult.products.length > 0) {
      <div>
        <h3 class="resultsText">
          Showing results for:
          <span class="textBold">{{ searchResult.freeTextSearch }}</span>
        </h3>
        <br />
      </div>
    }

    @if (searchResult && searchResult.products.length == 0) {
      <div>
        <h3 class="resultsText">
          Showing no results for:
          <span class="textBold">{{ searchResult.freeTextSearch }}</span>
        </h3>
      </div>
    }
  </div>
</div>
